// extracted by mini-css-extract-plugin
export default {"deleteMessage":"ConfirmSaveModal_deleteMessage__8qtjF","title":"ConfirmSaveModal_title__fozxP","actionsModal":"ConfirmSaveModal_actionsModal__+v9yP"};